import moment from "moment";
import InfiniteScroll from "react-infinite-scroll-component";

import { Notifications } from "@mui/icons-material";
import { useEffect, useMemo, useRef, useState } from "react";
import { Badge, Divider, IconButton, Menu, useMediaQuery } from "@mui/material";
import { Box, Modal, Avatar, Typography, useCommonComponentContext } from "@maysoft/common-component-react";

import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import Resources from "../../constants/resources";
import NotificationService, { IRecordNotification } from "../../services/message/Notification.service";

import { IPagedList } from "../../commons/interfaces";
import { MessageType, ReadStatus } from "../../constants/enums";
import {
    navBell_text,
    navBell_icon,
    navBell_btnBox,
    navBell_popper,
    navBell_itemMenu,
    navBell_btn_ReadAll,
} from "./styles";


export interface IDataRequestNotification {
    messageType?: number;
    readStatus?: number;
    pageNumber?: number;
}

const dataNotifiDefault: IPagedList<IRecordNotification> = {
    hasNext: false,
    hasPrevious: false,
    pageSize: 0,
    totalPages: 0,
    totalCount: 0,
    currentPage: 0,
    items: [],
}

export const renderTime = (time: number) => {
    if (time === 0) {
        return "";
    } else {
        const fromNowStr = `${moment.unix(time).fromNow()}`.replace("a few ", "");
        return fromNowStr;
        // const timeStr = moment.unix(time).format(Constants.DateFormat.HHMM_DDMMYYYY);
        // return `${fromNowStr} - (${timeStr})`;
    }
};

export const renderString = (value: string) => {
    let string = value.replace(/<style([\s\S]*?)<\/style>/gi, "");
    string = string.replace(/<script([\s\S]*?)<\/script>/gi, "");
    string = string.replace(/<\/div>/gi, "\n");
    string = string.replace(/<\/li>/gi, "\n");
    string = string.replace(/<li>/gi, "  *  ");
    string = string.replace(/<\/ul>/gi, "\n");
    string = string.replace(/<\/p>/gi, "\n");
    string = string.replace(/<br\s*[\/]?>/gi, ". ");
    string = string.replace(/<[^>]+>/gi, "");
    return string.replace(/<[^>]+>/g, "");
};

function BellNotification(props: {
    totalUnRead?: number;
    onRead: (data: IRecordNotification) => void;
    getTotalUnRead: (totalUnRead: number) => void;
    isShowPopupDetail?: (data: IRecordNotification) => boolean;
}): JSX.Element {

    const Strings = useStrings();
    const anchorEl = useRef<HTMLButtonElement>(null);
    const isMobile = useMediaQuery("(max-height: 768px)");

    const {
        clientId,
        language,
        userInfo,
        serviceCode,
        onError,
    } = useCommonComponentContext();

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isBtnAll, setIsBtnAll] = useState(true);
    const [totalUnRead, setTotalUnRead] = useState(0);
    const [isPermissionNotifi, setIsPermissionNotifi] = useState(false);
    const [dataReq, setDataReq] = useState<IDataRequestNotification>({});
    const [dataNotifiAll, setDataNotifiAll] = useState<IPagedList<IRecordNotification>>(dataNotifiDefault);
    const [dataNotifiUnRead, setDataNotifiUnRead] = useState<IPagedList<IRecordNotification>>(dataNotifiDefault);

    const [dataModalDetailNotifi, setDataModalDetailNotifi] = useState<{
        open: boolean;
        data?: IRecordNotification;
    }>({ open: false });

    const newDataNotifi = useMemo(() => {
        if (isBtnAll) {
            return { ...dataNotifiAll };
        } else {
            return { ...dataNotifiUnRead };
        }
    }, [isBtnAll, dataNotifiUnRead, dataNotifiAll]);

    useEffect(() => {
        setTotalUnRead(props.totalUnRead || 0);
    }, [props.totalUnRead]);

    // close popup notifi
    const handleClose = (event: React.MouseEvent<EventTarget>) => {
        if (anchorEl.current && anchorEl.current.contains(event.target as HTMLElement)) {
            return;
        }
        setOpen(false);
    };

    // open popup notifi
    const handleToggle = () => { setOpen(prevOpen => !prevOpen); };

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false && anchorEl.current) {
            anchorEl.current?.focus();
        }
        prevOpen.current = open;

        setIsBtnAll(true);
        setDataNotifiAll(dataNotifiDefault);
        setDataNotifiUnRead(dataNotifiDefault);

        // getTotalUnreadNotification();

        getPageNotification();
    }, [userInfo?.userProfile?.organizationId]);

    const checkPermissionNotifi = async () => {
        Notification.requestPermission().then((permission) => {
            // permission: "default" | "denied" | "granted"
            if (permission === "granted") {
                setIsPermissionNotifi(true);
            } else {
                setIsPermissionNotifi(false);
            }
        }).catch((error) => {
            setIsPermissionNotifi(false);
        });
    }

    // Get total Unread notification
    // const getTotalUnreadNotification = async () => {
    //     try {
    //         const result = await NotificationService.getPaged({
    //             organizationId: userInfo?.userProfile?.organizationId,
    //             serviceCode: serviceCode,
    //             clientId: clientId,
    //             pageNumber: 1,
    //             pageSize: 1,
    //             messageType: MessageType.PushNotification,
    //         });

    //         setTotalUnRead(result.unReadTotal || 0);
    //         props.getTotalUnRead(result.unReadTotal || 0);
    //     } catch (error) {
    //         setTotalUnRead(0);
    //         props.getTotalUnRead(0);
    //     }
    // }

    // Getpaged notification
    const getPageNotification = async (data?: IDataRequestNotification) => {
        const req: any = {
            clientId: clientId,
            serviceCode: serviceCode,
            organizationId: userInfo?.userProfile?.organizationId,
            pageNumber: data?.pageNumber || 1,
            pageSize: 10,

            readStatus: data?.readStatus,
            messageType: MessageType.PushNotification,
        };

        try {
            setLoading(true);

            let oldItems: IRecordNotification[] = (req?.pageNumber > 1)
                ? (
                    (req?.readStatus === ReadStatus.UnRead)
                        ? [...dataNotifiUnRead?.items]
                        : [...dataNotifiAll?.items]
                )
                : [];

            const result = await NotificationService.getPaged(req);
            const newItems = [...result.pageValue?.items];

            const dataTemp: IPagedList<IRecordNotification> = {
                hasNext: result.pageValue?.hasNext,
                pageSize: result.pageValue?.pageSize,
                totalPages: result.pageValue?.totalPages,
                totalCount: result.pageValue?.totalCount,
                currentPage: result.pageValue?.currentPage,
                hasPrevious: result.pageValue?.hasPrevious,
                items: [...oldItems, ...newItems],
            };

            setDataReq(req);

            setTotalUnRead(result.unReadTotal || 0);
            props.getTotalUnRead(result.unReadTotal || 0);

            if (req?.readStatus === ReadStatus.UnRead) {
                setDataNotifiUnRead(dataTemp);
            } else {
                setDataNotifiAll(dataTemp);
            }

            setLoading(false);
        } catch (error: any) {
            if (req?.readStatus === ReadStatus.UnRead) {
                setDataNotifiUnRead(dataNotifiDefault);
            } else {
                setDataNotifiAll(dataNotifiDefault);
            }

            setDataReq(req);
            setLoading(false);
        }
    };

    // Read notification by id_notifi
    const readNotificationById = async (id: string, readStatus: number) => {
        if (readStatus === ReadStatus.UnRead) {
            try {
                const result = await NotificationService.readNotificationById(id);

                if (result.statusCode === 200) {
                    let dataTempUnRead: IRecordNotification[] = [...dataNotifiUnRead.items].filter(el => el.id !== id);

                    let dataTempAll = [...dataNotifiAll.items];
                    const index = dataTempAll.findIndex(el => el.id === id);
                    if (index !== -1) {
                        dataTempAll[index] = {
                            ...dataTempAll[index],
                            readStatus: ReadStatus.Read,
                        };
                    }

                    const newValue = ((totalUnRead - 1) > 0) ? (totalUnRead - 1) : 0;

                    setTotalUnRead(newValue);
                    props.getTotalUnRead(newValue);

                    setDataNotifiUnRead({
                        ...dataNotifiUnRead,
                        items: dataTempUnRead,
                    });
                    setDataNotifiAll({
                        ...dataNotifiAll,
                        items: dataTempAll,
                    });
                }
            } catch (error) {
                const e = Helpers.renderExceptionError(error);
                onError(e);
            }
        }
    };

    // Read all notification
    const readAllNotificationById = async () => {
        try {
            const result = await NotificationService.readAllNotification(clientId);
            if (result.statusCode === 200) {
                let dataTempAll: IRecordNotification[] = [...dataNotifiAll?.items].map(el => {
                    return { ...el, readStatus: ReadStatus.Read };
                });

                setTotalUnRead(0);
                props.getTotalUnRead(0);

                setDataNotifiUnRead({
                    ...dataNotifiUnRead,
                    items: [],
                });
                setDataNotifiAll({
                    ...dataNotifiAll,
                    items: dataTempAll,
                });
            }
        } catch (error) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        }
    };

    // Dialog Show Notification Detail
    const renderModalDetailNotification = () => (
        <Modal
            fullWidth
            maxWidth="sm"
            title={Strings.Common.NOTIFICATION}
            visible={dataModalDetailNotifi?.open || false}
            onClose={() => { setDataModalDetailNotifi({ open: false }); }}
        >
            <Box>
                <Box mb={1} display="flex">
                    <Box pr={2}>
                        <Avatar
                            src={Resources.THUMBNAIL}
                            style={{ border: "1px #c3c3c3 solid" }}
                        />
                    </Box>
                    <Box sx={{ lineHeight: 1 }}>
                        <Typography variant="h5">
                            {
                                Helpers.renderValueByLanguage({
                                    data: dataModalDetailNotifi?.data?.title,
                                    currentLanguage: language,
                                })
                            }
                        </Typography>
                        <Typography
                            variant="caption"
                            fontWeight="medium"
                            color={
                                (dataModalDetailNotifi?.data?.readStatus || 0) === ReadStatus.UnRead
                                    ? "info"
                                    : "secondary"
                            }
                        >
                            {renderTime(Number(dataModalDetailNotifi?.data?.sendTime))}
                        </Typography>
                    </Box>
                </Box>
                <Divider />
                <Box sx={navBell_text} mt={2} px={1} mb={2}>
                    {Helpers.renderValueByLanguage({
                        data: dataModalDetailNotifi?.data?.content,
                        currentLanguage: language,
                    }) && (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: Helpers.renderValueByLanguage({
                                        data: dataModalDetailNotifi?.data?.content,
                                        currentLanguage: language,
                                    }),
                                }}
                            />
                        )}
                </Box>
            </Box>
        </Modal>
    );

    // Box record notification information
    const renderRecordNotifi = (item: IRecordNotification) => (
        <div
            key={item.id}
            onClick={async () => {
                setOpen(false);

                readNotificationById(item.id, item.readStatus || 0);

                Helpers.isFunction(props.onRead) && props.onRead(item);

                const isShowPopup = Helpers.isFunction(props.isShowPopupDetail) ? props.isShowPopupDetail(item) : false;

                if (isShowPopup) {
                    setDataModalDetailNotifi({
                        open: true,
                        data: item,
                    });
                }
            }}
        >
            <Box sx={navBell_itemMenu} >
                <Box width="96%" display="flex" alignItems="flex-start">
                    <Box px={2}>
                        <Avatar
                            src={Resources.THUMBNAIL}
                            style={{ border: "1px #c3c3c3 solid" }}
                        />
                    </Box>
                    <Box display="inline-grid">
                        <Box>
                            <Typography variant="button" fontWeight="bold">
                                {
                                    Helpers.renderValueByLanguage({
                                        data: item.title,
                                        currentLanguage: language,
                                    })
                                }
                            </Typography>
                        </Box>
                        <Box style={{
                            lineHeight: "0",
                            padding: "4px 0px",
                            overflow: "hidden",
                            WebkitLineClamp: "3",
                            whiteSpace: "initial",
                            display: "-webkit-box",
                            textOverflow: "ellipsis",
                            WebkitBoxOrient: "vertical",
                        }}>
                            <Typography variant="button">
                                {
                                    renderString(Helpers.renderValueByLanguage({
                                        data: item.content,
                                        currentLanguage: language,
                                    }))
                                }
                            </Typography>
                        </Box>
                        <Typography
                            variant="caption"
                            color="secondary"
                            fontWeight="medium"
                        >
                            {renderTime(Number(item.sendTime))}
                        </Typography>
                    </Box>
                </Box>
                <Box width="4%">
                    <Box sx={(theme) => {
                        const { palette } = theme;
                        return {
                            width: 15,
                            height: 15,
                            borderRadius: 15 / 2,
                            backgroundColor:
                                isBtnAll && ((item.readStatus || 0) === ReadStatus.UnRead)
                                    ? palette.primary.main
                                    : undefined,
                        }
                    }}>
                    </Box>
                </Box>
            </Box>
            <Divider />
        </div>
    );

    // Box loading
    const renderTextLoading = () => {
        let value = "";
        if ([...newDataNotifi?.items].length === 0) {
            value = Strings.Common.NO_DATA;
        } else {
            if (newDataNotifi.totalCount !== [...newDataNotifi?.items].length) {
                value = Strings.Common.LOADING;
            } else {
                value = "";
            }
        }

        return (
            <Box sx={{
                width: "100%",
                display: "flex",
                alignItems: "end",
                justifyContent: "center",
                height: ([...newDataNotifi?.items].length === 0) ? "90%" : undefined,
            }}>
                {
                    loading
                        ? <Typography variant="caption" fontWeight="bold">
                            {Strings.Common.LOADING}
                        </Typography>
                        : <Typography variant="caption" fontWeight="bold">
                            {value}
                        </Typography>
                }
            </Box>
        );
    }

    // Box action button
    const renderActionButton = () => (
        <Box mx={2.25} mt={0} display="flex" alignItems="end">
            <Box
                sx={navBell_btnBox}
                borderBottom={(theme) => {
                    const { palette } = theme;
                    return `2px ${isBtnAll ? palette.primary.main : "#fffff"} solid`;
                }}
                onClick={async () => {
                    if (!isBtnAll) {
                        setIsBtnAll(true);
                        await getPageNotification({
                            pageNumber: 1,
                            readStatus: undefined
                        });
                    }
                }}
            >
                <Typography
                    variant="button"
                    fontWeight={isBtnAll ? "bold" : "regular"}
                    sx={(theme) => {
                        const { palette } = theme;
                        return { color: isBtnAll ? palette.primary.main : "#0000008a" };
                    }}
                >
                    {Strings.Common.ALL}
                </Typography>
            </Box>
            <Box
                sx={navBell_btnBox}
                borderBottom={(theme) => {
                    const { palette } = theme;
                    return `2px ${!isBtnAll ? palette.primary.main : "#fffff"} solid`;
                }}
                onClick={async () => {
                    if (isBtnAll) {
                        setIsBtnAll(false);
                        await getPageNotification({
                            pageNumber: 1,
                            readStatus: ReadStatus.UnRead,
                        });
                    }
                }}
            >
                <Typography
                    variant="button"
                    fontWeight={!isBtnAll ? "bold" : "regular"}
                    sx={(theme) => {
                        const { palette } = theme;
                        return { color: !isBtnAll ? palette.primary.main : "#0000008a" };
                    }}
                >
                    {Strings.Common.UNREAD}
                </Typography>
            </Box>
            {(totalUnRead > 0) && (
                <Box
                    sx={navBell_btn_ReadAll}
                    onClick={async () => { readAllNotificationById(); }}>
                    <Typography id="text_readAll"
                        variant="caption"
                        sx={(theme) => {
                            const { palette } = theme;
                            return { color: palette.primary.main };
                        }}
                    >
                        {Strings.Common.MARK_READ_ALL}
                    </Typography>
                </Box>
            )}
        </Box>
    );

    return (
        <div style={{ display: "contents" }}>
            <IconButton
                edge="start"
                id="icon_bell"
                ref={anchorEl}
                sx={navBell_icon}
                aria-haspopup="true"
                aria-label="Notification"
                aria-controls={open ? "list_notifi" : undefined}
                onClick={async () => {
                    (!open) && checkPermissionNotifi();

                    handleToggle();
                    setIsBtnAll(true);

                    if (dataNotifiAll?.items?.length <= 0) {
                        getPageNotification();
                    }
                }}
            >
                <Badge
                    max={99}
                    color="primary"
                    badgeContent={(totalUnRead || 0) > 0 ? (totalUnRead || 0) : 0}
                >
                    <Notifications />
                </Badge>
            </IconButton>

            <Menu
                open={open}
                id="list_notifi"
                anchorReference={null}
                anchorEl={anchorEl.current}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                onClose={handleClose}
            >
                <Box sx={navBell_popper}>
                    <Typography sx={{ paddingLeft: "9px" }} variant="h5">{Strings.Common.NOTIFICATION}</Typography>

                    {renderActionButton()}

                    <Divider />

                    <Box id="scrollableDiv" mt={1}>
                        <InfiniteScroll
                            hasMore={true}
                            dataLength={[...newDataNotifi?.items].length}
                            height={([...newDataNotifi?.items].length === 0) ? 100 : (isMobile ? 280 : 350)}
                            loader={renderTextLoading()}
                            next={async () => {
                                const hasNext = isBtnAll ? dataNotifiAll?.hasNext : dataNotifiUnRead?.hasNext;
                                if (hasNext) {
                                    getPageNotification({
                                        ...dataReq,
                                        pageNumber: (dataReq.pageNumber || 0) + 1,
                                    });
                                }
                            }}
                        >
                            {
                                [...newDataNotifi?.items].map((item) => (renderRecordNotifi(item)))
                            }
                        </InfiniteScroll>
                    </Box>

                    <Box sx={{
                        padding: "6px",
                        display: "grid",
                        textAlign: "center",
                        borderTop: "1px solid #c3c3c3",
                    }}>
                        {
                            !isPermissionNotifi &&
                            <Typography variant="button" color="error">
                                {Strings.Common.DENIED_PERMISSION_NOTIFI}
                            </Typography>
                        }
                        {
                            !isPermissionNotifi &&
                            <Typography variant="button">{Strings.Common.PLEASE_SEE} &nbsp;
                                <a href="#" style={{ fontWeight: 600, color: "blue", textDecoration: "underline" }}>
                                    {Strings.Common.HERE}
                                </a>
                            </Typography>
                        }
                    </Box>
                </Box>
            </Menu>
            {renderModalDetailNotification()}
        </div>
    );
}

export default BellNotification;
